<script lang="ts" setup>
import { useBibleTranslations } from '~/composables/useBibleData'

const { testament = 'old' } = defineProps<{
  testament?: string
}>()

const { data: translations } = await useBibleTranslations()
</script>

<template>
  <div v-if="translations" class="overflow-x-scroll hidden-scroll w-full">
    <div class="flex md:flex-wrap gap-2">
      <TagLink
        v-for="translation in translations"
        :key="translation.code"
        :href="`/bible/${translation.code}/testament/${testament}/`"
      >
        {{ translation.name }}
      </TagLink>
    </div>
  </div>
</template>

<style scoped></style>
